export default __webpack_public_path__ + "static/media/sulfitos.4b546eeb.svg";